export default __webpack_public_path__ + "static/media/grafema_clivitalbio_06.0678d129.jpg";